import Model from "~/models/_Model";

export default class Status extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "statuses";
  }

  relations() {
    return {};
  }

  // Computed Attributes
}
